import { Component, Input, OnInit } from "@angular/core";
import { PlayerDto } from "app/models";

@Component({
    selector: 'tactic-player-vertical-info',
    templateUrl: './tactic-player-vertical-info.component.html',
    styleUrls: ['./tactic-player-vertical-info.component.scss'],
})
export class TacticPlayerVerticalInfo implements OnInit {
    private pl: PlayerDto;


    @Input()
    set player(val: PlayerDto){
        this.pl = val;
        this.init();
    }

    get player(): PlayerDto {
        return this.pl;
    }

    @Input()
    isSubst: boolean;

    form: number;
    morale: number;

    ngOnInit(): void {
        this.init();
    }

    getPlayerPower(): any {
        if (!this.player) {
            return null;
        }

        return this.player.power;
    }

    private init() {
        this.form  = this.getPlayerForm();
        this.morale = this.getPlayerMorale();
    }

    private getPlayerMorale(): any {
        if (!this.player) {
            return null;
        }

        return this.player.morale;
    }

    private getPlayerForm(): number {
        if (!this.player) {
            return null;
        }

        return this.player.form;
    }
}